import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { cloneDeep, isEmpty } from 'lodash';
import { AddCircleOutline } from '@material-ui/icons';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { ExpertiseState } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { Listings } from 'containers/AppContainer/typings';
import ExpertiseAddForm from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/ExpertiseAddForm';
import { EMPTY_EXPERTISE } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/constants';
import ActionButton from 'components/Buttons/ActionButton';
import messages from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/messages';
import { translate } from 'containers/services/translate';
import { ExpertiseFormsWrapper } from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/styled-components';
import { VictimType } from 'typings/globalTypes';

export interface ExpertiseAddFormsProps {
  intl: IntlShape;
  listings: Listings;
  victims: VictimType[];
  vehicules: Vehicule[];
  expertises: ExpertiseState[];
  setExpertises: Function;
  setExpertiseDate?: any;
  expertiseDate?: any;
  judgementAddPronouncing?: any;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  isBasicManagement?: boolean;
}

const ExpertiseAddForms: React.FC<ExpertiseAddFormsProps> = (
  props,
): JSX.Element => {
  const handleSetExpertise = (index: number) => (expertise: ExpertiseState) => {
    const expertises = [...props.expertises];
    expertises[index] = expertise;

    props.setExpertises(expertises);
  };

  const addNewExpertise = () =>
    props.setExpertises([...props.expertises, cloneDeep(EMPTY_EXPERTISE)]);

  const deleteExpertise = (index: number) => () => {
    const expertises = [...props.expertises];

    expertises.splice(index, 1);

    props.setExpertises(expertises);
  };

  return (
    <ExpertiseFormsWrapper>
      <section className="expertises">
        <article className="expertise-forms-title">
          {translate(messages.expertisesSectionTitle, props)}
        </article>
        <ActionButton
          onClick={addNewExpertise}
          title={translate(messages.addExpertise, props)}
          lefticon={<AddCircleOutline className="icon" />}
        />
      </section>
      {!isEmpty(props.expertises) &&
        props.expertises.map((expertise, index: number) => (
          <ExpertiseAddForm
            key={index}
            listings={props.listings}
            victims={props.victims}
            vehicules={props.vehicules}
            expertise={expertise}
            handleSetExpertise={handleSetExpertise(index)}
            index={index}
            deleteExpertise={deleteExpertise(index)}
            setExpertiseDate={props.setExpertiseDate}
            expertiseDate={props.expertiseDate}
            judgementAddPronouncing={props.judgementAddPronouncing}
            sagisVictimInfo={props.sagisVictimInfo}
            sagisOpposingParties={props.sagisOpposingParties}
            isBasicManagement={props.isBasicManagement}
          />
        ))}
    </ExpertiseFormsWrapper>
  );
};

export default injectIntl(ExpertiseAddForms);
